import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumb = ({ current }) => (
  <nav aria-label="breadcrumb" data-testid="page-breadcrumb" className="flex items-center gap-2 text-xs uppercase tracking-[0.15em] text-white/40 mb-8">
    <Link to="/" data-testid="breadcrumb-home-link" className="hover:text-twp-gold transition-colors">
      Inicio
    </Link>
    <ChevronRight size={12} />
    <span data-testid="breadcrumb-current" className="text-white/70">{current}</span>
  </nav>
);
